module.exports = __webpack_public_path__ + "img/8-on.ccf08096.png";